import api from '../token';

export const ListFPagamento = async () => {
  try {
    const response = await api.post('/getFPagamento');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

